package ui.new_ui.requirements

import web.cssom.Length
import web.cssom.px

interface MinRequirements {
    val minHeight: Length
        get() = 10.px
    val minWidth: Length
        get() = 60.px
}